import Nullstack from 'nullstack';
export default function IconTank({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-tank",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "2",
    y: "12",
    width: "18",
    height: "6",
    rx: "3"
  }), "   ", Nullstack.element("path", {
    d: "M6 12l1 -5h5l3 5"
  }), "   ", Nullstack.element("line", {
    x1: "21",
    y1: "9",
    x2: "13.2",
    y2: "9"
  }), " ");
}